module.exports = __webpack_public_path__ + "img/ic-ba-acc-emedia.08049ba8.svg";